// Returns true if a mouse pointer is available
// credit:
// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser#comment95674193_51774045

export const isMobileDevice = (): boolean =>
  !window.matchMedia('(any-pointer:fine)').matches
